export default "__VITE_ASSET__cbd50a2d__"